import React from "react";
import format from "@app/lib/format";

const Title = ({ article = {} }) => {
    return (
        <>
            C{article.mdrId} -{" "}
            <span
                dangerouslySetInnerHTML={{
                    __html: format.formatTitle(article.title),
                }}
            />
        </>
    );
};

export default Title;
